const StyleTag = ({ children }) => (
  <style dangerouslySetInnerHTML={{ __html: children }} />
);

export default StyleTag;
